import './index.scss';

(() => {
  const links = document.querySelectorAll('.nav_footer_link_menu');

  for (const link of links) {
    link.addEventListener('click', () => {
      if (window?.dataLayer) {
        window.dataLayer.push({
          event: 'click_menu_footer',
          menu_item: link?.textContent
        });
      }
    });
  }
})();
